import {hideToast} from "./action";


const hideToastAction = () => hideToast();

export default {
    hideToastAction
};
